const formatPositiveAmount = (amount) => {
    'worklet';
    let result = amount.toFixed(2);
    const firstComma = result.length - 6;
    if (firstComma > 0) {
        const nChunks = Math.ceil((result.length - 3) / 3);
        const chunks = [];
        for (let i = 0, pos = firstComma; i < nChunks; i += 1, pos -= 3) {
            chunks.unshift(result.substr(pos < 0 ? 0 : pos, pos < 0 ? 3 + pos : 3));
        }
        result = chunks.join(',').concat(result.slice(-3));
    }
    return result;
};
const formatAmount = (amount, currencySymbol) => {
    'worklet';
    if (amount < 0) {
        return `-${currencySymbol}${formatPositiveAmount(Math.abs(amount))}`;
    }
    return `${currencySymbol}${formatPositiveAmount(amount)}`;
};
export default formatAmount;
